export const AlgorithmList: { key: string; value: string; description?: string }[] = [
  {key: '=MP1', value: '=MP1', description: 'meteringpoint.calculation.descriptions.mp1'},
  {key: '=(MP1-MP2)', value: '=(MP1-MP2)', description: 'meteringpoint.calculation.descriptions.mp1minusmp2'},
  {
    key: '=POS(MP1-MP2)Year',
    value: '=POS(MP1-MP2) pr år',
    description: 'meteringpoint.calculation.descriptions.posmp1mp2annual'
  },
  {key: '=POS(MP1-MP2)', value: '=POS(MP1-MP2)', description: 'meteringpoint.calculation.descriptions.posmp1mp2'},
  {key: '=(MP1+MP2-MP3)', value: '=(MP1+MP2-MP3)', description: 'meteringpoint.calculation.descriptions.mp1mp2mp3'},
  {
    key: '=POS(MP1+MP2-MP3)',
    value: '=POS(MP1+MP2-MP3)',
    description: 'meteringpoint.calculation.descriptions.posmp1mp2mp3'
  },
  {key: '=(MP1+MP2)', value: '=(MP1+MP2)', description: 'meteringpoint.calculation.descriptions.mp1plusmp2'},
  {
    key: '=EstimatedAnnualVolume',
    value: '=FordeltForventetÅrsforbrug',
    description: 'meteringpoint.calculation.descriptions.annual'
  },
  {key: '=(MP1+MP2+[...])', value: '=(MP1+MP2+[...])', description: 'meteringpoint.calculation.descriptions.dynamic'},
  {key: '=ShareDistribute(MP1;MP2;MP3+[...])', value: '=Forholdsfordelt', description: 'meteringpoint.calculation.descriptions.forholdsfordelt'},
];
